// extracted by mini-css-extract-plugin
export var checkIcon = "FormField-module--checkIcon--a26d0";
export var closeTooltip = "FormField-module--closeTooltip--b10e1";
export var fadeInAnimation = "FormField-module--fadeInAnimation--21553";
export var formField = "FormField-module--formField--4ec71";
export var phoneTooltip = "FormField-module--phoneTooltip--aadba";
export var text = "FormField-module--text--6013f";
export var tooltip = "FormField-module--tooltip--9b1a9";
export var withIcon = "FormField-module--withIcon--739a3";
export var withoutError = "FormField-module--withoutError--83197";